import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Widgets from "./Widgets";
import { openSearch } from "../../state/modules/search";
import { getTotalQuantity, getUpdated } from "../../state/modules/bag";
import { isLoggedIn, getIsReconsentRequired } from "../../state/modules/user";
import {
  hasSavedItems,
  getSavedItemsFromSDK
} from "../../state/modules/savedItems";
import { getViewport, addLastFocusElement } from "../../state/modules/layout";
import { getDropdownIsOpen } from "../../state/modules/dropdown";
import {
  getDefaultLanguage,
  getCountryCode,
  getStoreCode,
  getKeyStoreDataversion,
  getDefaultStoreUrl
} from "../../state/modules/regionalStore";
import { getFeature } from "../../state/modules/features";

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      openSearch,
      getSavedItemsFromSDK,
      addLastFocusElement
    },
    dispatch
  );

const mapStateToProps = state => ({
  eventIconToggle: getFeature(state, "web-event-icon"),
  countryCode: getCountryCode(state),
  defaultStoreUrl: getDefaultStoreUrl(state),
  hasSavedItems: hasSavedItems(state),
  isLoggedIn: isLoggedIn(state),
  isReconsentRequired: getIsReconsentRequired(state),
  isUpdated: getUpdated(state),
  keyStoreDataversion: getKeyStoreDataversion(state),
  lang: getDefaultLanguage(state),
  miniBagToggle: getFeature(state, "stc-minibag-dropdown"),
  myAccountOpen: getDropdownIsOpen(state, { name: "myAccount" }),
  noOfBagItems: getTotalQuantity(state),
  storeCode: getStoreCode(state),
  viewport: getViewport(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(Widgets);
